import type { Category } from "@/types/content";

export const categories: Category[] = [
  {
    id: "culture",
    name: "文化",
    en: "Culture",
    slogan: "在旧事物里，找到新的提问方式",
    description:
      "从独立书店、手作工坊到地方戏曲与城市记忆，文化频道记录那些缓慢但真实的创造。我们相信传统不是被供起来的标本，而是每天都有人在重新使用的生活素材。",
    icon: "ri-quill-pen-line",
  },
  {
    id: "entertainment",
    name: "娱乐",
    en: "Entertainment",
    slogan: "镜头之外的行业，故事之内的人",
    description:
      "剧集、电影、音乐与综艺的现场观察。娱乐频道不只聊热搜，也聊片场里的三小时、音乐节背后的成本表，以及内容工业如何把情绪做成产品。",
    icon: "ri-film-line",
  },
  {
    id: "life",
    name: "生活",
    en: "Life",
    slogan: "把日常过成可以反复阅读的细节",
    description:
      "厨房、街区、通勤路线与周末计划。生活频道提供可执行的实验，也承认大多数改变都很小：早一点关灯，把一顿饭认真做完。",
    icon: "ri-leaf-line",
  },
  {
    id: "opinion",
    name: "观点",
    en: "Opinion",
    slogan: "慢一点判断，多一点理由",
    description:
      "关于内容行业、平台机制与媒介习惯的长期思考。观点频道不追逐结论，更在意一个判断是如何被推出来的。",
    icon: "ri-chat-quote-line",
  },
];

export const categoryMap: Record<string, Category> = categories.reduce(
  (acc, item) => {
    acc[item.id] = item;
    return acc;
  },
  {} as Record<string, Category>,
);